<template>
  <div class="dataTables_length">
    <label>
      Hiển thị &nbsp;
      <select aria-controls="DataTables_Table_0"
              class="custom-select custom-select-sm form-control form-control-sm"
              name="DataTables_Table_0_length"
              :value="value"
              @input="onInput($event.target.value)"

      >
        <option value="10">10</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select> &nbsp;
      dòng dữ liệu
    </label>
  </div>
</template>

<script>
export default {
  name: "CTableLength",
  props: {
    value: {
      type: [Number, String]
    }
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
    }
  }
}
</script>

<style scoped>

</style>